<div class="mb-3">
  <div class="d-flex align-items-center gap-2 mb-1">
    <label class="form-label mb-0 flex-grow-1"><i class="mdi mdi-draw-pen text-warning me-1"></i>{{ label }}</label>
    <ng-container *ngIf="showPad && strokes.length">
      <button type="button" class="btn btn-sm btn-light" [disabled]="disabled" (click)="undo()">
        <i class="mdi mdi-undo-variant me-1"></i>Geri Al
      </button>
      <button type="button" class="btn btn-sm btn-light" [disabled]="disabled" (click)="clear()">
        <i class="mdi mdi-eraser me-1"></i>Temizle
      </button>
    </ng-container>
  </div>
  <div class="text-muted small mb-2" *ngIf="description">{{ description }}</div>

  <ng-container *ngIf="hasExisting && !redrawing; else padTpl">
    <div class="sig-paper">
      <img [src]="existingSvgUrl" alt="Kayıtlı imza">
    </div>
    <div class="d-flex gap-2 justify-content-end mt-2">
      <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="disabled" (click)="redrawing = true">
        <i class="mdi mdi-draw me-1"></i>Yeniden İmzala
      </button>
      <button type="button" class="btn btn-sm btn-outline-danger" [disabled]="disabled" (click)="removeExisting()">
        <i class="mdi mdi-trash-can-outline me-1"></i>İmzayı Kaldır
      </button>
    </div>
  </ng-container>

  <ng-template #padTpl>
    <div class="sig-paper" [class.disabled]="disabled">
      <!-- Basılı formdaki imza çizgisi; tuval saydam, çizginin üstünde çizilir. -->
      <div class="sig-line"></div>
      <span class="sig-x">×</span>
      <span class="sig-placeholder" *ngIf="!strokes.length">Buraya imza atın</span>
      <canvas #canvas aria-label="İmza alanı" role="img"
        (pointerdown)="pointerDown($event)"
        (pointermove)="pointerMove($event)"
        (pointerup)="pointerUp($event)"
        (pointercancel)="pointerUp($event)"></canvas>
    </div>
    <div class="text-warning small mt-1" *ngIf="tooShort">İmza çok kısa; lütfen tam imza atın.</div>
    <button type="button" class="btn btn-link btn-sm p-0 mt-1" *ngIf="redrawing" (click)="keepExisting()">
      Kayıtlı imzayı koru
    </button>
  </ng-template>

  <div class="small text-warning mt-1" *ngIf="existingSvg && existingRemoved">
    Kayıtlı imza kaydedince silinecek.
    <button type="button" class="btn btn-link btn-sm p-0 align-baseline" (click)="restoreExisting()">Geri Al</button>
  </div>
</div>
